import SuggestedPostDetail from './SuggestedPostDetail';
export default SuggestedPostDetail;
